import { Image } from '@round/ui-kit';
import { assets } from '@round/whitelabel-ui';
import styles from './AgencyPayeeBadge.module.css';

const { UserGroup: UserGroupIcon } = assets;

type Props = {
    name: string;
    imageUrl?: string | null;
};

const AgencyPayeeBadge = ({ name, imageUrl }: Props) => {
    return (
        <div className={styles.container}>
            <Image
                src={imageUrl ?? undefined}
                alt={`${name} image`}
                className={styles.image}
                Fallback={UserGroupIcon}
            />
            <div className={styles.name}>{name}</div>
        </div>
    );
};

export default AgencyPayeeBadge;
